import { Controller } from '@hotwired/stimulus';

import showFlash from '~/utils/flash';

export default class extends Controller {
  static targets = ['input', 'button', 'preview', 'removeImageBtn', 'removeImage', 'shade'];
  static values = {
    maxSize: { type: Number, default: 5 }, // in MB
    acceptedTypes: { type: Array, default: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'] },
  };

  selectImage() {
    this.inputTarget.click();
  }

  putShade() {
    if (this.hasShadeTarget) {
      this.shadeTarget.style.opacity = '100';
    }
  }

  removeShade(){
    if (this.hasShadeTarget) {
      this.shadeTarget.style.opacity = '0';
    }
  }

  createObjectURL() {
    if (this.inputTarget.files && this.inputTarget.files[0]) {
      const imageFile = this.inputTarget.files[0];
      if (imageFile) {
        if (!this.isValidImageSize(imageFile)) {
          this.inputTarget.files = new DataTransfer().files;
          const message = `Image size must be less than ${this.maxSizeValue} MB.`;
          showFlash(message, { type: 'error', autoClose: 60000 });
        } else if (!this.isValidFileType(imageFile)) {
          this.inputTarget.files = new DataTransfer().files;
          const acceptedTypesString = this.acceptedTypesValue.map((type) => type.split('/').pop()).join(', ');
          const message = `We only allow images in these formats to be uploaded: ${acceptedTypesString}.`;
          showFlash(message, { type: 'error', autoClose: 60000 });
        } else {
          this.previewTargets.forEach(img => img.src = URL.createObjectURL(imageFile));
          this.removeImageBtnTarget.classList.remove('hidden');
          this.removeImageTarget.value = false;
          this.removeShade();
        }
      }
    }
  }

  isValidImageSize(imageFile) {
    return (imageFile.size < this.maxSizeValue * 1000 * 1000);
  }

  isValidFileType(imageFile) {
    return this.acceptedTypesValue.includes(imageFile.type);
  }

  onRemove() {
    this.previewTargets.forEach(img => img.src = '');
    this.removeImageTarget.value = true;
    this.removeImageBtnTarget.classList.add('hidden');
  }
}
